/* ============================================================
   LLL free mini line (2026-10). Replaces the July prototype.
   Keeps exactly one Lay Lay Mini per muslin blanket in the cart, as its own line. The
   "Free Lay Lay Mini" discount prices it $0.
   - quantity always = muslin units x perTrigger; the teddy never counts; removed with the muslin
   - checkout (cart drawer + /cart buttons) waits until the cart is right; so do the /cart express
     buttons (hidden by CSS until <html> gets .lll-gift-ready). Never waits more than 4 seconds.
   - fails safe: if the line ever isn't $0 at the right count (discount off or not combining), it is
     removed and this tab stops re-adding it (the old "Your free mini…" cart note was retired 4 Oct;
     the order-worker safety net still adds the line to the order)
   Config: window.LLL_FREE_GIFT from snippets/lll-free-gift.liquid.
   ============================================================ */
(function () {
  var C = window.LLL_FREE_GIFT || {};
  var GIFT_VID = C.giftVariantId, GIFT_PID = C.giftProductId;
  var TRIG = C.triggerProductIds || [], PER = C.perTrigger || 1;
  if (!GIFT_VID || !GIFT_PID || !TRIG.length) return;

  var R = window.routes || {};
  var CART = R.cart_url || '/cart';
  // Renamed 5 Oct 2026 (was 'lll_free_gift_off'): the add race below switched tabs off by mistake, and
  // those tabs start adding the gift again under the new key.
  var OFF_KEY = 'lll_free_gift_off2';
  // Cross-page add marker (5 Oct 2026). 'Buy 2 Blankets' adds to the cart and jumps to /cart at once: the
  // page being left and the cart page could BOTH add the gift (4 minis for 2 blankets), the extra 2 were
  // charged and the fail safe removed every gift. A page about to add leaves this marker; another page that
  // sees a fresh one waits for it instead of adding again.
  var ADD_KEY = 'lll_free_gift_adding', ADD_HOLD_MS = 2500;
  var MAX_WAIT_MS = 4000;
  var busy = false, queued = false, ready = false, waiters = [], forceUI = false;

  function off() { try { return sessionStorage.getItem(OFF_KEY) === '1'; } catch (e) { return false; } }
  function setOff() { try { sessionStorage.setItem(OFF_KEY, '1'); } catch (e) {} }
  function addingElsewhere() { try { var t = +sessionStorage.getItem(ADD_KEY); return !!t && (Date.now() - t) < ADD_HOLD_MS; } catch (e) { return false; } }
  function markAdding(on) { try { if (on) sessionStorage.setItem(ADD_KEY, String(Date.now())); else sessionStorage.removeItem(ADD_KEY); } catch (e) {} }
  function getCart() {
    return fetch(CART + '.js', { cache: 'no-store', headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); });
  }
  function post(path, body) {
    return fetch(CART + path, {
      method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body)
    }).then(function (r) { return r.ok ? r.json() : null; });
  }
  function wanted(cart) {
    var n = 0;
    (cart.items || []).forEach(function (i) { if (TRIG.indexOf(i.product_id) > -1) n += i.quantity; });
    return off() ? 0 : n * PER;
  }
  function gifts(cart) { return (cart.items || []).filter(function (i) { return i.product_id === GIFT_PID; }); }
  function giftUnits(cart) { return gifts(cart).reduce(function (s, i) { return s + i.quantity; }, 0); }

  function setReady(v) {
    ready = v;
    document.documentElement.classList.toggle('lll-gift-ready', v);
    if (v) { var w = waiters; waiters = []; w.forEach(function (fn) { try { fn(); } catch (e) {} }); }
  }

  // One pass towards exactly `want` gift units on a single line. Resolves true if it changed the cart.
  function step(cart) {
    var want = wanted(cart), g = gifts(cart), have = giftUnits(cart);
    if (want === have && g.length <= 1) return Promise.resolve(false);
    var u = {};
    if (want === 0) {
      g.forEach(function (i) { u[i.key] = 0; });
      return post('/update.js', { updates: u }).then(function () { return true; });
    }
    if (!g.length) {
      markAdding(true);
      return post('/add.js', { items: [{ id: GIFT_VID, quantity: want, properties: { _lll_gift: '1' } }] })
        .then(function () { markAdding(false); return true; }, function () { markAdding(false); return true; });
    }
    g.forEach(function (i, k) { u[i.key] = k === 0 ? want : 0; });
    return post('/update.js', { updates: u }).then(function () { return true; });
  }

  // Fail safe: every gift unit must come to $0, or the line goes.
  function guard(cart) {
    var g = gifts(cart);
    if (!g.length || g.every(function (i) { return i.final_line_price === 0; })) return Promise.resolve(false);
    setOff();
    var u = {};
    g.forEach(function (i) { u[i.key] = 0; });
    return post('/update.js', { updates: u }).then(function () { return true; });
  }

  var tries = 0;
  function reconcile() {
    if (busy) { queued = true; return; }
    if (addingElsewhere()) { setReady(false); setTimeout(reconcile, 500); return; }  // another page is adding: wait for it
    busy = true;
    setReady(false);
    var changed = false;
    getCart()
      .then(function (cart) { return step(cart).then(function (c) { changed = c; return c ? getCart() : cart; }); })
      .then(function (cart) {
        // Something else can change the gift count while this pass runs, so correct it once more first.
        if (giftUnits(cart) === wanted(cart) && gifts(cart).length <= 1) return cart;
        return step(cart).then(function (c) { changed = changed || c; return c ? getCart() : cart; });
      })
      .then(function (cart) {
        // The fail safe only judges prices at the RIGHT count; a wrong count is re-run (at most 3 times).
        if (giftUnits(cart) !== wanted(cart) || gifts(cart).length > 1) { if (tries++ < 3) queued = true; return; }
        tries = 0;
        return guard(cart).then(function (c) { changed = changed || c; });
      })
      .then(function () { var f = forceUI; forceUI = false; return (changed || f) ? refreshUI() : null; })
      .catch(function () {})
      .then(function () {
        busy = false;
        if (queued) { queued = false; reconcile(); } else { setReady(true); }
      });
  }

  // Re-render the drawer, the cart bubble and the /cart page sections (same approach as Dawn's own
  // remove button, so an emptied drawer keeps its empty state).
  function refreshUI() {
    var P = function (h) { return new DOMParser().parseFromString(h || '', 'text/html'); };
    var getSection = function (id) {
      return fetch(CART + '?section_id=' + id, { cache: 'no-store' }).then(function (r) { return r.ok ? r.text() : null; }).catch(function () { return null; });
    };
    var swap = function (host, doc, sel) { if (!host) return; var c = host.querySelector(sel), s = doc.querySelector(sel); if (c && s) c.innerHTML = s.innerHTML; };
    var jobs = [];
    var cd = document.querySelector('cart-drawer');
    if (cd) jobs.push(getSection('cart-drawer').then(function (h) {
      if (h == null) return;
      var d = P(h); swap(cd, d, '.drawer__inner');
      var f = d.querySelector('cart-drawer'); if (f) cd.classList.toggle('is-empty', f.classList.contains('is-empty'));
    }));
    var cb = document.getElementById('cart-icon-bubble');
    if (cb) jobs.push(getSection('cart-icon-bubble').then(function (h) {
      if (h == null) return;
      var d = P(h), f = d.querySelector('.shopify-section') || d.body; if (f) cb.innerHTML = f.innerHTML;
    }));
    // /cart page. Fetch each section by the page's own section id (data-id): asking for the file name
    // renders it with DEFAULT settings, whose footer has no totals, so the old total stayed on screen
    // after the gift was removed (Thomas, 5 Oct: "$12.99 remains even when nothing in cart").
    ['main-cart-items', 'main-cart-footer'].forEach(function (id) {
      var el = document.getElementById(id);
      if (el) jobs.push(getSection(el.getAttribute('data-id') || id).then(function (h) { if (h != null) swap(el, P(h), '.js-contents'); }));
    });
    // Dawn only toggles the empty state for its own changes, so mirror it when ours empties the cart.
    if (document.getElementById('main-cart-items') || document.getElementById('main-cart-footer')) {
      jobs.push(getCart().then(function (cart) {
        var empty = !cart.item_count;
        var mi = document.getElementById('main-cart-items'), ci = mi && mi.closest('cart-items');
        if (ci) ci.classList.toggle('is-empty', empty);
        var mf = document.getElementById('main-cart-footer'); if (mf) mf.classList.toggle('is-empty', empty);
      }).catch(function () {}));
    }
    return Promise.all(jobs).catch(function () {});
  }

  // Checkout waits for the line (max 4 s, so checkout is never blocked by this script).
  document.addEventListener('click', function (e) {
    var b = e.target && e.target.closest && e.target.closest('#CartDrawer-Checkout, #checkout, button[name="checkout"], input[name="checkout"]');
    if (!b || ready) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    waiters.push(function () { b.click(); });
    setTimeout(function () { if (!ready) setReady(true); }, MAX_WAIT_MS);
  }, true);

  // 1) Dawn's own cart updates (product form, drawer quantity, removes).
  try {
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.cartUpdate) {
      subscribe(PUB_SUB_EVENTS.cartUpdate, function () { reconcile(); });
    }
  } catch (e) {}

  // 2) Cart calls that don't publish (bundle buttons, custom quick-adds). Our own calls run while busy.
  if (window.fetch) {
    var _f = window.fetch;
    window.fetch = function () {
      var u = arguments[0]; u = (u && u.url) ? u.url : u;
      var p = _f.apply(this, arguments);
      if (!busy && typeof u === 'string' && /\/cart\/(add|change|update|clear)(\.js)?(\?|$)/.test(u)) {
        setReady(false);
        p.then(function () { setTimeout(reconcile, 90); }, function () { setTimeout(reconcile, 90); });
      }
      return p;
    };
  }

  // 3) Page load and back/forward. Back (e.g. from checkout) can show the browser's saved copy of the page
  //    from before the last cart change: empty drawer, no count on the cart icon, although the cart itself
  //    is fine (Thomas, 4 Oct; the theme did this before the free mini too). So a page shown by Back or
  //    Forward always re-renders the cart UI once it has reconciled.
  try { var nav = performance.getEntriesByType('navigation')[0]; forceUI = !!(nav && nav.type === 'back_forward'); } catch (e) {}
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', reconcile);
  else reconcile();
  // A gift add from the page just left can land after this page has reconciled. One quiet look 3s in
  // fixes the count if so (no button flicker unless something actually needs fixing).
  setTimeout(function () {
    if (busy) return;
    getCart().then(function (cart) { if (giftUnits(cart) !== wanted(cart) || gifts(cart).length > 1) reconcile(); }).catch(function () {});
  }, 3000);
  window.addEventListener('pageshow', function (e) { if (e.persisted) { forceUI = true; reconcile(); } });
  setTimeout(function () { if (!ready && !busy) setReady(true); }, MAX_WAIT_MS);
})();

/* Quantity 0 in the cart removes the line (Thomas, 4 Oct). The theme's cart.js rejects anything under
   the line's minimum ("This item has a minimum of 1"), so a typed 0, or the minus button at 1, left the
   line in place with an error. This catches that change before cart.js sees it and presses the line's
   own remove button instead, which is the theme's normal remove path (the gift then follows as usual).
   Independent of the gift config on purpose: it is a plain cart fix. */
(function () {
  document.addEventListener('change', function (e) {
    var input = e.target;
    if (!input || !input.matches || !input.matches('cart-items input.quantity__input, cart-drawer-items input.quantity__input')) return;
    var v = String(input.value).trim();
    if (v === '' || Number(v) !== 0) return;
    var row = input.closest('.cart-item');
    var rm = row && row.querySelector('cart-remove-button');
    if (!rm) return;
    e.stopImmediatePropagation();
    rm.click();
  }, true);
})();
